export default __webpack_public_path__ + "0fc93d45595e5650e697904e1f68cfa2.png";